/**
 * Validates an email address format.
 * Uses a safe regex pattern that prevents ReDoS (Regular Expression Denial of Service) attacks.
 * 
 * @param email - The email address to validate
 * @returns true if the email format is valid, false otherwise
 */
export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

/**
 * Gets notification labels based on what's being delegated.
 * 
 * @param hasFiles - Whether files are being delegated
 * @param hasQuestions - Whether questions are being delegated
 * @returns Object with labels for each notification preference option
 */
export const getNotificationLabels = (hasFiles: boolean, hasQuestions: boolean) => {
  const hasBoth = hasFiles && hasQuestions;

  if (hasBoth) {
    return {
      each: 'Notify me on each upload/answer',
      all: 'Notify me on completion (one email for documents, one for questions)',
      none: 'No notifications',
    };
  }
  
  if (hasQuestions) {
    return {
      each: 'Notify me when each question is answered',
      all: 'Notify me when all questions are answered',
      none: 'No notifications',
    };
  }
  
  return {
    each: 'Notify me when each document is uploaded',
    all: 'Notify me when all documents are uploaded',
    none: 'No notifications',
  };
};
